var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMapLabelEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#78D62E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_7568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4569 8.13056C22.4479 7.97766 22.3832 7.83336 22.2749 7.72505C22.1666 7.61675 22.0223 7.55199 21.8694 7.54306C15.9217 7.19384 11.1576 8.98447 9.1264 12.3438C8.42231 13.493 8.07535 14.8254 8.12952 16.172C8.16489 17.0331 8.34009 17.8827 8.64827 18.6876C8.66638 18.7371 8.69673 18.7813 8.7365 18.8159C8.77626 18.8506 8.82415 18.8746 8.8757 18.8857C8.92725 18.8969 8.98078 18.8948 9.03131 18.8797C9.08183 18.8646 9.12772 18.8369 9.16468 18.7993L15.8053 12.0571C15.8634 11.9991 15.9323 11.953 16.0082 11.9216C16.0841 11.8901 16.1654 11.874 16.2475 11.874C16.3296 11.874 16.4109 11.8901 16.4868 11.9216C16.5627 11.953 16.6316 11.9991 16.6897 12.0571C16.7477 12.1152 16.7938 12.1841 16.8252 12.26C16.8567 12.3359 16.8728 12.4172 16.8728 12.4993C16.8728 12.5814 16.8567 12.6627 16.8252 12.7386C16.7938 12.8145 16.7477 12.8834 16.6897 12.9415L9.43265 20.3079L8.32406 21.4165C8.20876 21.5287 8.13993 21.6803 8.13125 21.8409C8.12256 22.0016 8.17466 22.1597 8.27718 22.2837C8.33333 22.3487 8.40227 22.4014 8.47972 22.4386C8.55716 22.4758 8.64144 22.4966 8.72728 22.4998C8.81313 22.5029 8.89871 22.4884 8.97867 22.457C9.05863 22.4256 9.13126 22.378 9.19202 22.3173L10.5037 21.0056C11.6084 21.5399 12.7233 21.8313 13.8287 21.8704C13.9157 21.8735 14.0024 21.8751 14.0889 21.8751C15.3478 21.8783 16.5828 21.5316 17.6561 20.8735C21.0155 18.8423 22.8069 14.079 22.4569 8.13056Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_7568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapLabelEtc);
export default __webpack_public_path__ + "static/media/icon-map-label-etc.14ec5b041493868a3b53216af53f6bd9.svg";
export { ForwardRef as ReactComponent };